import Typography from '~/components/Typography'

export type MainInvestorCardProps = {
  fullName: string
  jobTitle: string
  description: string
}

const MainInvestorCard = ({
  fullName,
  jobTitle,
  description
}: MainInvestorCardProps) => {
  return (
    <figure className="rounded-md bg-white/5">
      <figcaption className="flex flex-col gap-y-3 border-b-1.5 border-black/80 p-8">
        <Typography align="center">{fullName}</Typography>
        <Typography
          variant="subtitle2"
          align="center"
          className="text-white/50"
        >
          {jobTitle}
        </Typography>
      </figcaption>
      <Typography
        component="blockquote"
        variant="body2"
        className="px-8 py-6 text-white/80 max-md:text-center"
      >
        {description}
      </Typography>
    </figure>
  )
}

export default MainInvestorCard
